import { render, staticRenderFns } from "./Gps.vue?vue&type=template&id=52579cfc"
import script from "./Gps.vue?vue&type=script&lang=js"
export * from "./Gps.vue?vue&type=script&lang=js"
import style0 from "./Gps.vue?vue&type=style&index=0&id=52579cfc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports